import { render, staticRenderFns } from "./GroupsStats.vue?vue&type=template&id=59c9f1f9&scoped=true&"
import script from "./GroupsStats.vue?vue&type=script&lang=js&"
export * from "./GroupsStats.vue?vue&type=script&lang=js&"
import style0 from "./GroupsStats.vue?vue&type=style&index=0&id=59c9f1f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9f1f9",
  null
  
)

export default component.exports